import axios from 'axios'

const ENDPOINT = 'vocabulary'

export default {
  delete: async (centro_id, id) => {
    const url = `${centro_id}/${ENDPOINT}/${id}/`
    const response = await axios.delete(url)

    return response.data
  },

  get: async (centro_id, id) => {
    const url = `${centro_id}/${ENDPOINT}/${id}/`
    return await axios.get(url)
  },

  getAll: async centro_id => {
    const url = `${centro_id}/${ENDPOINT}/`
    const response = await axios.get(url)

    return response.data
  },

  post: async (centro_id, data) => {
    const url = `${centro_id}/${ENDPOINT}/`
    const response = await axios.post(url, data)

    return response.data
  },

  put: async (centro_id, id, data) => {
    const url = `${centro_id}/${ENDPOINT}/${id}/`
    return await axios.put(url, data)
  },

  getQVocabularyItems: async (centro_id) => {
    let url = `${centro_id}/${ENDPOINT}/`
    const response = await axios.get(url)

    return response.data
  },

  copyFromParent: async centro_id => {
    const url = `${centro_id}/${ENDPOINT}/copy_from_parent/`
    const response = await axios.get(url)

    return response.data
  },
}
